//@ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    Button,
    IconButton,
    Select,
    MenuItem,
    Menu,
    InputLabel,
    FormControl,
    TextField,
    Chip,
    createTheme,
    ThemeProvider,
    Autocomplete,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    useMediaQuery,
    CircularProgress,
    useTheme,
    Tooltip
} from '@mui/material';
import { InputControl, NumericFormatInputControl } from '../../molecules';
import { useGetMerchantAccountHistory, useGetMerchantsWithParentMerchant, useGetMerchantCurrentBalanceTypeSettingsList, useMerchantCurrentBalanceMovement, GetMerchantAccountHistoryListRequest, useGetMerchantWithLatestMovementDetail, PagingResponse, useAuthorization, useMerchantCurrentBalanceMovementUpdate, useMerchantCurrentBalanceMovementDelete, useConfirmationModal } from '../../../hooks';
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { Table } from '../../../components';
import {
    GridColDef,
    GridPaginationModel,
    GridValueFormatterParams,
} from "@mui/x-data-grid";
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { MerchantAccoutFormValuesType, merchantAccoutSchema } from './_formTypes';
import { zodResolver } from '@hookform/resolvers/zod';
import { useLocation } from 'react-router-dom';
import { downloadExcel } from "../../../util/downloadExcel";
import { ViewSidebar, ViewSidebarOutlined } from '@mui/icons-material';
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';

import { Loading } from '../../../components';
import MoreVertOutlined from '@mui/icons-material/MoreVertOutlined';

interface TransactionStatus {
    id: number;
    key: string;
    value: string;
}

interface Merchant {
    id: number;
    merchantName: string;
    taxNumber: string;
    merchantId: number;
    parentMerchantId: number;
    status: string;
}

interface TableDataType {
    result: any[];
    totalItems: number;
}
// const theme = createTheme({
//     palette: {
//         primary: { main: '#1976D2' },
//         secondary: { main: '#9C27B0' },
//         error: { main: '#F44336' },
//         info: { main: '#2196F3' },
//         background: { default: '#F5F7FA' },
//         text: { primary: '#333', secondary: '#666' },
//     },
//     typography: {

//     },
// });

export type GridColDefExt = GridColDef & { columnType?: RequestFilterValueTypeEnums };

export const MerchantAccount = ({ merchant }: any) => {
    const { handleSubmit, control, setValue, watch, formState: { errors } } =
        useForm<MerchantAccoutFormValuesType>({
            resolver: zodResolver(merchantAccoutSchema),
            defaultValues: {
                transactionType: 1,
                amount: null,
                description: ''
            },
        });

    const theme = useTheme();
    const { showDelete, showUpdate, showCreate } = useAuthorization();
    const [isMerchantDetayDrawerActive, setIsMerchantDetayDrawerActive] = useState(false);
    const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetMerchantsWithParentMerchant();
    const [selectedMerchant, setSelectedMerchant] = useState<Merchant | null>(null);
    const [transactionType, setTransactionType] = useState<number>(1);
    const [amount, setAmount] = useState<number>(0);
    const [description, setDescription] = useState<string>('');
    const [openModal, setOpenModal] = useState(false);
    const { mutate: merchantCurrentBalanceMovement, isLoading: merchantCurrentBalanceMovementLoading } = useMerchantCurrentBalanceMovement();
    const { mutate: merchantCurrentBalanceUpdate, isLoading: merchantCurrentBalanceMovementUpdateLoading } = useMerchantCurrentBalanceMovementUpdate();
    const { mutate: getMerchantWithLatestMovementDetail, isLoading: isMerchantLastMovementLoading } = useGetMerchantWithLatestMovementDetail();
    const { mutate: getMerchantAccountHistoryListMutation, isLoading } = useGetMerchantAccountHistory();
    const [movementDetail, setMovementDetail] = useState<any>({});
    const [selectedType, setSelectedType] = useState<any>(null);
    const [selectedTypeChanged, setSelectedTypeChanged] = useState<any>(null);

    // Add new state to track modal operation type
    const [modalMode, setModalMode] = useState<'insert' | 'update'>('insert');
    const [selectedRow, setSelectedRow] = useState<any>(null);

    const { mutate: merchantCurrentBalanceDelete } = useMerchantCurrentBalanceMovementDelete();
    const { showConfirmationModal } = useConfirmationModal();

    var isPageLoading = isMerchantListLoading ||
        isMerchantLastMovementLoading ||
        merchantCurrentBalanceMovementLoading ||
        isLoading;

    const setSnackbar = useSetSnackBar();
    interface QueryOptions {
        field?: string;
        value?: any;
        clearFilter?: boolean;
        [key: string]: string | number | boolean | undefined | any;
    }

    const [queryOptions, setQueryOptions] = React.useState<QueryOptions>({});
    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
        page: 0,
        pageSize: 25,
    });
    const { data: rawTransactionStatusList } = useGetMerchantCurrentBalanceTypeSettingsList({});

    const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const location = useLocation();
    const [mercantIdentification, setMercantIdentification] = useState<boolean>(false);
    const [dynamicFilters, setDynamicFilter] = useState<any>([]);
    const [selectedCurrency, setSelectedCurrency] = useState<string>('TRY');

    useEffect(() => {
        if (location?.pathname === '/merchant-management/merchant-identification') {
            setMercantIdentification(true)
            setSelectedMerchant({ id: merchant.merchantId, merchantId: merchant.merchantId, merchantName: merchant.merchantName, taxNumber: merchant.taxNumber, parentMerchantId: merchant.parentMerchantId, status: merchant.status });
        } else {
            const savedMerchant = localStorage.getItem('selectedMerchant');
            if (savedMerchant) {
                setSelectedMerchant(JSON.parse(savedMerchant));
            } else if (rawMerchantList?.data?.length) {
                setSelectedMerchant(rawMerchantList.data[0]);
            }
        }
    }, [location, rawMerchantList])

    useEffect(() => {
        if (!selectedMerchant) {
            return;
        }
        getMerchantWithLatestMovementDetail(
            { id: String(selectedMerchant?.merchantId || 0), currency: selectedCurrency },
            {
                onSuccess: (data) => {
                    setMovementDetail(data?.data);
                },
                onError: () => {
                    setSnackbar({
                        severity: "error",
                        description: "İşlem sırasında bir hata oluştu",
                        isOpen: true,
                    });
                },
            }
        );

    }, [selectedMerchant, getMerchantWithLatestMovementDetail, selectedCurrency])

    /*     useEffect(() => {
            if (selectedMerchant && !mercantIdentification) {
                localStorage.setItem('selectedMerchant', JSON.stringify(selectedMerchant));
            } else {
                localStorage.removeItem('selectedMerchant');
            }
        }, [selectedMerchant]); */

    useEffect(() => {

        const requestPayload: GetMerchantAccountHistoryListRequest = {
            pageSize: paginationModel.pageSize,
            page: paginationModel.page || 0,
            orderBy: "CreateDate",
            orderByDesc: true,
            merchantId: selectedMerchant?.merchantId || 0,
            filters: dynamicFilters || [],
            currency: selectedCurrency, // Use selected currency here
            ...getQueryParams(queryOptions),
        };

        if (selectedType) {
            var findData = requestPayload.filters.find(x => x.field == 'merchantCurrentBalanceType');

            if (findData) {
                findData.values = [selectedType.value];
            } else {
                requestPayload.filters.push({
                    field: 'merchantCurrentBalanceType',
                    values: [selectedType.value],
                    valueType: RequestFilterValueTypeEnums.STRING,
                    operationType: RequestFilterOperationTypeEnum.CONTIANS
                });
            }
        } else if (selectedTypeChanged) {
            requestPayload.filters = requestPayload.filters.filter(x => x.field !== "merchantCurrentBalanceType");
        }

        if (!selectedMerchant) {
            return;
        }
        if (queryOptions?.field && queryOptions?.value !== undefined) {
            requestPayload[queryOptions.field] = queryOptions.value;
        }

        getMerchantAccountHistoryListMutation(
            requestPayload,
            {
                onSuccess: (data) => {
                    if (data.isSuccess) {
                        setTableData(data?.data);
                    } else {
                        setSnackbar({
                            severity: "error",
                            description: data.message,
                            isOpen: true,
                        });
                    }
                },
                onError: () => {
                    setSnackbar({
                        severity: "error",
                        description: "İşlem sırasında bir hata oluştu",
                        isOpen: true,
                    });
                },
            }
        );
    }, [
        paginationModel.page,
        paginationModel.pageSize,
        setSnackbar,
        queryOptions,
        selectedType,
        selectedCurrency,
        selectedMerchant
    ]);


    const onSubmit = (data: MerchantAccoutFormValuesType) => {
        if (!selectedMerchant) {
            setSnackbar({
                severity: "warning",
                isOpen: true,
                description: "Lütfen önce bir firma seçiniz",
            });
            return;
        }

        const currentStatus = rawTransactionStatusList?.data?.find((x: { id: number, key: string }) => x.id == data.transactionType);

        if (!currentStatus) {
            setSnackbar({
                severity: "warning",
                isOpen: true,
                description: "Lütfen önce işlem tipi seçiniz!",
            });
            return;
        }

        const formData = {
            merchantCurrentBalanceTypeId: currentStatus.id,
            merchantCurrentBalanceType: currentStatus.id,
            amount: data.amount,
            description: data.description,
            merchantId: selectedMerchant.merchantId,
            currency: selectedCurrency,
            ...(modalMode === 'update' && { id: selectedRow.id }), // Add id for updates
        };

        // Use different mutation based on mode
        const mutation = modalMode === 'update'
            ? merchantCurrentBalanceUpdate  // You'll need to implement this
            : merchantCurrentBalanceMovement;

        mutation(formData, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: `${modalMode === 'update' ? 'Güncelleme' : 'Kayıt'} başarılı`,
                    });
                    setOpenModal(false);
                    // Reset form and state
                    setValue('transactionType', 1);
                    setValue('amount', null);
                    setValue('description', '');
                    setModalMode('insert');
                    setSelectedRow(null);
                    // Refresh list
                    getMerchantAccountHistoryListMutation({
                        pageSize: paginationModel.pageSize,
                        page: paginationModel.page || 0,
                        orderBy: "CreateDate",
                        orderByDesc: true,
                        currency: selectedCurrency,
                        merchantId: selectedMerchant?.merchantId || 0,
                        ...getQueryParams(queryOptions),
                    }, {
                        onSuccess: (data) => {
                            if (data.isSuccess) {
                                setTableData(data?.data);
                            } else {
                                setSnackbar({
                                    severity: "error",
                                    description: data.message,
                                    isOpen: true,
                                });
                            }
                        },
                        onError: () => {
                            setSnackbar({
                                severity: "error",
                                description: "İşlem sırasında bir hata oluştu",
                                isOpen: true,
                            });
                        },
                    });
                    getMerchantWithLatestMovementDetail(
                        { id: String(selectedMerchant?.merchantId || 0), currency: selectedCurrency },
                        {
                            onSuccess: (data) => {
                                setMovementDetail(data?.data);
                            },
                            onError: () => {
                                setSnackbar({
                                    severity: "error",
                                    description: "İşlem sırasında bir hata oluştu",
                                    isOpen: true,
                                });
                            },
                        }
                    );

                } else {
                    setSnackbar({
                        severity: "error",
                        isOpen: true,
                        description: data.message || "Bir hata oluştu",
                    });
                }
            },
            onError: (error) => {
                setSnackbar({
                    severity: "error",
                    isOpen: true,
                    description: "İşlem sırasında bir hata oluştu",
                });
            },
        });

        setIsMerchantDetayDrawerActive(false);

    };

    const debounce = (func: (...args: any[]) => void, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    interface FilterParams {
        [key: string]: string | number | boolean | null | undefined;
    }

    const getQueryParams = (filters: FilterParams) => {
        const queryParams: { [key: string]: string | number | boolean } = {};

        for (let key in filters) {
            let value = filters[key];
            // Eğer gelen değer string "false" ise onu boolean false'a çevir
            if (value === "false") {
                queryParams[key] = false;
            } else {
                if (value !== null && value !== undefined && value.toString().length > 0) {
                    queryParams[key] = value;
                }
            }
        }
        return queryParams;
    };

    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            setDynamicFilter([]);
            return setQueryOptions({});
        }
        const queryParams = getQueryParams(filters);

        const isValueValid = (key: string, value: any): boolean => {
            if (key === 'installmentCount' || key === 'cardType') { // Özel alan kontrolü
                return value?.toString().length >= 1;
            } else {
                return value?.toString().length >= 3;
            }
        }

        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));
        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        // Eğer queryParams bir önceki ile aynıysa işlem yapma
        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
            setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
        }


        // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
        previousQueryParams.current = queryParams;

    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    // Komponent içerisinde
    const previousQueryParams = React.useRef({});

    const [menuAnchorEl, setMenuAnchorEl] = useState<{ [key: string]: HTMLElement | null }>({});

    const handleRowDelete = (params: any) => {
        showConfirmationModal({
            title: 'İşlem İptali',
            message: 'Bu işlemi iptal etmek istediğinizden emin misiniz?',
            onConfirm: () => {
                merchantCurrentBalanceDelete(
                    { id: params.row.id },
                    {
                        onSuccess: (response) => {
                            if (response.isSuccess) {
                                setSnackbar({
                                    severity: "success",
                                    isOpen: true,
                                    description: "İşlem başarıyla iptal edildi",
                                });
                                // Refresh the data after successful deletion
                                getMerchantAccountHistoryListMutation({
                                    pageSize: paginationModel.pageSize,
                                    page: paginationModel.page || 0,
                                    orderBy: "CreateDate",
                                    orderByDesc: true,
                                    currency: selectedCurrency,
                                    merchantId: selectedMerchant?.merchantId || 0,
                                    ...getQueryParams(queryOptions),
                                }, {
                                    onSuccess: (data) => {
                                        if (data.isSuccess) {
                                            setTableData(data?.data);
                                        } else {
                                            setSnackbar({
                                                severity: "error",
                                                description: data.message,
                                                isOpen: true,
                                            });
                                        }
                                    },
                                    onError: () => {
                                        setSnackbar({
                                            severity: "error",
                                            description: "İşlem sırasında bir hata oluştu",
                                            isOpen: true,
                                        });
                                    },
                                });
                                getMerchantWithLatestMovementDetail(
                                    { id: String(selectedMerchant?.merchantId || 0), currency: selectedCurrency },
                                    {
                                        onSuccess: (data) => {
                                            setMovementDetail(data?.data);
                                        },
                                        onError: () => {
                                            setSnackbar({
                                                severity: "error",
                                                description: "İşlem sırasında bir hata oluştu",
                                                isOpen: true,
                                            });
                                        },
                                    }
                                );
                            } else {
                                setSnackbar({
                                    severity: "error",
                                    isOpen: true,
                                    description: response.message || "İşlem iptal edilirken bir hata oluştu",
                                });
                            }
                        },
                        onError: (error) => {
                            setSnackbar({
                                severity: "error",
                                isOpen: true,
                                description: "İşlem iptal edilirken bir hata oluştu",
                            });
                        },
                    }
                );
            },
        });
        setMenuAnchorEl({}); // Close the menu after showing confirmation
    };

    // Modify handleRowUpdate function
    const handleRowUpdate = (params: any) => {
        setModalMode('update');
        setSelectedRow(params.row);
        // Pre-fill form data
        setValue('transactionType', params.row.merchantCurrentBalanceTypeId);
        setValue('amount', params.row.amount);
        setValue('description', params.row.explain?.split('/')[1]?.trim());
        setOpenModal(true);
        setMenuAnchorEl({});
    };

    const columns: GridColDefExt[] = useMemo(() => {
        return [
            {
                field: 'actions',
                headerName: '',
                filterable: false,
                sortable: false,
                width: 50,
                filter: false,
                renderCell: (params) => {
                    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
                        event.stopPropagation();
                        setMenuAnchorEl(prev => ({
                            ...prev,
                            [params.id]: event.currentTarget
                        }));
                    };

                    const handleClose = () => {
                        setMenuAnchorEl(prev => ({
                            ...prev,
                            [params.id]: null
                        }));
                    };

                    return (
                        <div>
                            <IconButton
                                disabled={(!showUpdate && !showDelete) || params.row.isEditable == false}
                                onClick={handleClick}
                                size="small"
                            >
                                <MoreVertOutlined />
                            </IconButton>
                            <Menu
                                anchorEl={menuAnchorEl[params.id]}
                                open={Boolean(menuAnchorEl[params.id])}
                                onClose={handleClose}
                            >
                                {showUpdate && (
                                    <MenuItem onClick={() => handleRowUpdate(params)}>
                                        Düzenle
                                    </MenuItem>
                                )}
                                {showDelete && (
                                    <MenuItem onClick={() => handleRowDelete(params)}>
                                        İptal Et
                                    </MenuItem>
                                )}
                            </Menu>
                        </div>
                    );
                }
            },
            { field: 'merchantName', headerName: 'Müşteri Adı', width: 120, columnType: RequestFilterValueTypeEnums.STRING },
            {
                field: 'date', headerName: 'İşlem Tarihi', width: 150, renderCell: (params) => {
                    if (!params.value) return "";
                    const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
                    if (formattedDate === "Invalid Date") return "";
                    return formattedDate;
                },
                columnType: RequestFilterValueTypeEnums.DATE
            },
            {
                field: 'vDate', headerName: 'Valör Tarih', width: 150, renderCell: (params) => {
                    if (!params.value) return "";
                    const formattedDate = dayjs(params.value).format("DD.MM.YYYY");
                    if (formattedDate === "Invalid Date") return "";
                    return formattedDate;
                },
                columnType: RequestFilterValueTypeEnums.DATE
            },
            {
                field: 'merchantCurrentBalanceType', headerName: 'İşlem Tipi', width: 120, columnType: RequestFilterValueTypeEnums.STRING
            },
            {
                field: 'amount', headerName: 'Tutar', width: 120,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams<number>) =>
                    `${params.value}`,
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'debt', headerName: 'Borç', width: 120, type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams<number>) =>
                    `${params.value}`,
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'credit', headerName: 'Alacak', width: 120, type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams<number>) =>
                    `${params.value}`,
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'balance', headerName: 'Bakiye', width: 200,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams<number>) =>
                    `${params.value}`,
                columnType: RequestFilterValueTypeEnums.NUMBER

            },
            { field: 'explain', headerName: 'Açıklama', width: 200, columnType: RequestFilterValueTypeEnums.STRING },
            { field: 'authCode', headerName: 'Otorizasyon Kodu', width: 200, columnType: RequestFilterValueTypeEnums.STRING },
            {
                field: 'endOfDayDate', headerName: 'Gün Sonu T.', width: 150, renderCell: (params) => {
                    if (!params.value) return "-";
                    const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
                    if (formattedDate === "Invalid Date") return "-";
                    return formattedDate;
                },
                columnType: RequestFilterValueTypeEnums.DATE
            },
        ];
    }, [menuAnchorEl, showUpdate, showDelete]);

    const convertTableFiltersToRequestFilter = (tableFilters: any) => {

        let convertedFilters: any = [];

        tableFilters.items.map((item: any) => {

            var findColumn = columns.find(x => x.field == item.field);

            convertedFilters.push({
                field: item.field,
                values: [item.value.toString()],
                valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
                operationType: mapReactMUIToFilterOperationTypes(item.operator)
            });
        });

        return convertedFilters;
    }

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
    };

    function fieldValue(data: any[]): Record<string, string | number | undefined>[] {
        return data.map((item) => {
            return {
                'Müşteri Adı': item?.merchantName,
                'İşlem Tarihi': dayjs(item?.date).format("DD.MM.YYYY HH:mm"),
                'Valör Tarih': dayjs(item?.vDate).format("DD.MM.YYYY HH:mm"),
                'İşlem Tipi': item?.merchantCurrentBalanceType,
                'Tutar': item?.amount ?? 0,
                'Borç': item?.debt ?? 0,
                'Alacak': item?.credit ?? 0,
                'Bakiye': item?.balance ?? 0,
                'Açıklama': item?.explain,
                'Otorizasyon Kodu': item?.authCode,
                'Gün Sonu T.': item?.endOfDayDate ? dayjs(item?.endOfDayDate).format("DD.MM.YYYY HH:mm") : "-",
            };
        });
    }
    const onSave = () => {

        const requestPayload: GetMerchantAccountHistoryListRequest = {
            pageSize: paginationModel.pageSize,
            page: paginationModel.page || 0,
            orderBy: "CreateDate",
            orderByDesc: true,
            merchantId: selectedMerchant?.merchantId || 0,
            downloadExcel: true,
            currency: selectedCurrency,
            ...getQueryParams(queryOptions),
        };

        if (queryOptions?.field && queryOptions?.value !== undefined) {
            requestPayload[queryOptions.field] = queryOptions.value;
        }

        getMerchantAccountHistoryListMutation(
            requestPayload,
            {
                onSuccess: (data) => {
                    if (data.isSuccess) {

                        const refactoredData = fieldValue(data?.data?.result);
                        downloadExcel(refactoredData || [], "Cari");
                    } else {
                        setSnackbar({
                            severity: "error",
                            description: data.message,
                            isOpen: true,
                        });
                    }
                },
                onError: () => {
                    setSnackbar({
                        severity: "error",
                        description: "İşlem sırasında bir hata oluştu",
                        isOpen: true,
                    });
                },
            }
        );
    };

    // Modify the "İşlem Yap" button click handler
    const handleNewTransaction = () => {
        setModalMode('insert');
        setSelectedRow(null);
        // Reset form
        setValue('transactionType', 1);
        setValue('amount', null);
        setValue('description', '');
        setOpenModal(true);
    };

    return (

        <ThemeProvider theme={theme}>
            {isPageLoading && <Loading />}
            <Box className="p-4" sx={{ p: 2 }}>
                <Box
                    className="mb-6 bg-white rounded-lg shadow-lg overflow-hidden"
                    sx={{
                        mb: 3,
                        backgroundColor: '#FFF',
                        borderRadius: 2,
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        border: '1px solid rgba(0, 0, 0, 0.05)'
                    }}>
                    <Box
                        className="p-6 flex justify-between items-center flex-wrap gap-4"
                        sx={{
                            p: 3,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 2,
                        }}>
                        <div className='flex gap-2'>
                            <Autocomplete<Merchant>
                                options={rawMerchantList?.data || []}
                                getOptionLabel={(option) => option?.merchantName + ` ( ${option.merchantId} )` || ''}
                                sx={{
                                    width: 350,
                                    height: "56px !important",
                                    display: mercantIdentification ? 'none !important' : 'block',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '4px',
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Firma Seçiniz"
                                        placeholder="Seçiniz"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {isMerchantListLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                loading={isMerchantListLoading}
                                loadingText="Yükleniyor..."
                                filterOptions={(options, { inputValue }) => {
                                    return options.filter(option =>
                                        option.merchantName.toLowerCase().includes(inputValue.toLowerCase()) ||
                                        option.merchantId.toString().includes(inputValue)
                                    );
                                }}
                                isOptionEqualToValue={(option, value) => option.merchantId === value.merchantId}
                                value={selectedMerchant}
                                onChange={(event, newValue) => {
                                    setSelectedMerchant(newValue);
                                }}
                                onInputChange={(event, newInputValue) => {
                                    if (newInputValue === '') {
                                        setSelectedMerchant(null);
                                        localStorage.removeItem('selectedMerchant');
                                    }
                                }}
                                freeSolo={false}
                                disableListWrap
                                selectOnFocus
                                clearOnBlur
                                handleHomeEndKeys
                            />
                            <Autocomplete
                                options={rawTransactionStatusList?.data || []}
                                getOptionLabel={(option) => option?.value || ''}
                                sx={{
                                    width: 200,
                                    height: "56px !important",
                                    display: mercantIdentification ? 'none !important' : 'block',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '4px',
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="İşlem Tipi"
                                        placeholder="Seçiniz"
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                value={selectedType}
                                onChange={(event, newValue) => {
                                    setSelectedType(newValue);
                                    setSelectedTypeChanged(true);
                                }}
                                onInputChange={(event, newInputValue) => {
                                    if (newInputValue === '') {
                                        setSelectedType(null);
                                        setSelectedTypeChanged(true);
                                    }
                                }}
                            />
                            <FormControl
                                sx={{
                                    width: 130,
                                    height: "56px !important",
                                    display: mercantIdentification ? 'none !important' : 'block'
                                }}
                            >
                                <TextField
                                    select
                                    label="Para Birimi"
                                    value={selectedCurrency}
                                    onChange={(e) => setSelectedCurrency(e.target.value)}
                                    sx={{
                                        width: '100%',
                                        '& .MuiOutlinedInput-root': {
                                            height: '56px',
                                            borderRadius: '4px'
                                        }
                                    }}
                                >
                                    {[{ value: 'TRY' }, { value: 'USD' }, { value: 'EUR' }
                                    ].map((currency: any, index: number) => (
                                        <MenuItem key={currency.value} value={currency.value}>
                                            {currency.value}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                            <Button
                                variant="outlined"
                                onClick={() => setIsMerchantDetayDrawerActive(true)}
                                sx={{
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    display: mercantIdentification ? 'none !important' : 'block',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    padding: '6px 16px'
                                }}
                            >
                                Firma Detayı
                            </Button>
                        </div>
                        <div className="flex gap-2">

                            <Tooltip title={!showCreate ? 'Yetkiniz bulunmamaktadır' : 'İşlem Yap'}>
                                <span>
                                    <Button
                                        variant="outlined"
                                        color='success'
                                        disabled={!showCreate}
                                        onClick={handleNewTransaction}
                                        sx={{
                                            display: mercantIdentification ? 'none !important' : 'block',
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                            padding: '6px 16px',
                                            height: "56px !important",
                                        }}
                                    >
                                        İşlem Yap
                                    </Button>
                                </span>
                            </Tooltip>

                            <Chip
                                label={`Bakiye : ${selectedCurrency} ${movementDetail?.finalBalance?.toLocaleString('tr-TR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }) || 0}`}
                                variant='outlined'
                                color={movementDetail?.finalBalance < 0 ? 'error' : 'success'}
                                sx={{
                                    borderRadius: '8px',
                                    fontSize: '0.95rem',
                                    fontWeight: 500,
                                    padding: '6px 16px',
                                    height: "56px !important",
                                }}
                            />
                        </div>
                    </Box>
                    <Dialog
                        open={openModal}
                        onClose={() => {
                            setOpenModal(false);
                            setModalMode('insert');
                            setSelectedRow(null);
                        }}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle>
                            {modalMode === 'insert' ? 'Manuel Cari Yönetimi' : 'İşlem Güncelle'}
                        </DialogTitle>
                        <DialogContent>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                                <FormControl sx={{ flex: isDesktop ? 1 : "auto", gap: 2 }}>
                                    <InputLabel>İşlem Tipi</InputLabel>
                                    <Select
                                        {...control.register('transactionType')}
                                        value={watch('transactionType')}
                                        onChange={(e) => {
                                            setValue('transactionType', Number(e.target.value));
                                        }}
                                        label="İşlem Tipi">
                                        <MenuItem
                                            key={1}
                                            value={1}
                                        >
                                            Seçiniz
                                        </MenuItem>
                                        {rawTransactionStatusList?.data?.map((item: TransactionStatus) => (
                                            <MenuItem
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {item.value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl sx={{ flex: isDesktop ? 1 : "auto", gap: 2, }}>
                                    <NumericFormatInputControl
                                        label="Çekilecek Tutar"
                                        control={control}
                                        id="amount"
                                        adornmentText={selectedCurrency}
                                        thousandSeparator=","
                                        decimalSeparator="."
                                        decimalScale={2}
                                        noNegative
                                        fixedDecimalScale
                                        allowEmptyFormatting={false}
                                        placeholder='0.00'
                                        onValueChange={(values) => {
                                            const { floatValue } = values;
                                            setValue('amount', floatValue || null);
                                        }}
                                    />
                                </FormControl>
                                <FormControl sx={{ flex: isDesktop ? 1 : "auto", gap: 2, mt: 2 }}>
                                    <InputControl
                                        fullWidth
                                        label="Açıklama"
                                        control={control}
                                        id="description"
                                    />
                                </FormControl>
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenModal(false)}>İptal</Button>
                            <Button
                                variant="contained"
                                onClick={handleSubmit(onSubmit)}
                                disabled={merchantCurrentBalanceMovementLoading}
                            >
                                {merchantCurrentBalanceMovementLoading ? (
                                    <CircularProgress size={24} color="inherit" />
                                ) : (
                                    'Kaydet'
                                )}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>

                {tableData && <Table
                    filterKey="merchantAccountTable"
                    columnVisibilityConfigKey="merchantAccountTableColumnVisibilityKey"
                    hasActiveFilters={hasActiveFilters}
                    handleFilterChange={handleFilterChange}
                    paginationModel={paginationModel}
                    onPaginationModelChange={handleChangePagination}
                    paginationMode="server"
                    rowCount={tableData?.totalItems || 0}
                    isRowSelectable={() => false}
                    customLabelDisplayedRows={true}
                    // disableColumnMenu
                    autoHeight={false}
                    getRowId={() => { return Math.floor(Math.random() * 100000) }}
                    rows={tableData?.result || []}
                    columns={columns}
                    getRowClassName={(params: { row: { status: string } }) => {
                        if (params.row.status === "PASSIVE") return "blocked-row";
                        if (params.row.status === "BLOCKED") return "pasive-row";
                        return "";
                    }}
                    exportFileName="Kullanıcı Listesi"
                    onSave={onSave}
                />}
            </Box>

            <Dialog
                open={isMerchantDetayDrawerActive}
                onClose={() => setIsMerchantDetayDrawerActive(false)}
                fullScreen
                sx={{
                    '& .MuiDialog-paper': {
                        width: '400px',
                        margin: 'auto',
                        marginRight: 0,
                        height: '100%',
                        maxWidth: '100%'
                    }
                }}
            >
                <Box sx={{ p: 2, height: '100%', backgroundColor: '#f5f5f5' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Typography variant="h6">Firma Detayları</Typography>
                        <IconButton onClick={() => setIsMerchantDetayDrawerActive(false)}>
                            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </IconButton>
                    </Box>

                    <Paper sx={{ p: 2, mb: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>Temel Bilgiler</Typography>
                        <Box sx={{ display: 'grid', gap: 2 }}>
                            <Box>
                                <Typography variant="caption" color="textSecondary">Firma Adı</Typography>
                                <Typography>{movementDetail?.merchantName || '-'}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="caption" color="textSecondary">Vergi Dairesi</Typography>
                                <Typography>{movementDetail?.taxOffice || '-'}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="caption" color="textSecondary">Vergi Numarası</Typography>
                                <Typography>{movementDetail?.taxNo || '-'}</Typography>
                            </Box>
                        </Box>
                    </Paper>

                    <Paper sx={{ p: 2, mb: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>Finansal Özet</Typography>
                        <Box sx={{ display: 'grid', gap: 2 }}>
                            <Box>
                                <Typography variant="caption" color="textSecondary">Toplam Bakiye</Typography>
                                <Typography>
                                    {movementDetail?.finalBalance
                                        ? `₺${Number(movementDetail.finalBalance).toLocaleString('tr-TR', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}`
                                        : '-'}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="caption" color="textSecondary">Son İşlem Tarihi</Typography>
                                <Typography>
                                    {movementDetail?.finalMovementDate
                                        ? dayjs(movementDetail.finalMovementDate).format('DD.MM.YYYY HH:mm:ss')
                                        : '-'}
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Box>
            </Dialog>
        </ThemeProvider>

    );
};